var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.0909 80.5H10.9091C8.90909 80.5 7.27273 78.8636 7.27273 76.8636V40.5C7.27273 38.5 8.90909 36.8636 10.9091 36.8636C12.9091 36.8636 14.5455 38.5 14.5455 40.5V73.2273H65.4545V40.5C65.4545 38.5 67.0909 36.8636 69.0909 36.8636C71.0909 36.8636 72.7273 38.5 72.7273 40.5V76.8636C72.7273 78.8636 71.0909 80.5 69.0909 80.5Z",
    fill: "#20262D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3636 44.1364H3.63636C1.63636 44.1364 0 42.5 0 40.5V22.3182C0 20.3182 1.63636 18.6818 3.63636 18.6818H76.3636C78.3636 18.6818 80 20.3182 80 22.3182V40.5C80 42.5 78.3636 44.1364 76.3636 44.1364ZM7.27273 36.8636H72.7273V25.9545H7.27273V36.8636Z",
    fill: "#20262D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 80.5C38 80.5 36.3636 78.8636 36.3636 76.8636V22.3182C36.3636 20.3182 38 18.6818 40 18.6818C42 18.6818 43.6364 20.3182 43.6364 22.3182V76.8636C43.6364 78.8636 42 80.5 40 80.5Z",
    fill: "#20262D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 25.9545H23.6364C16.6182 25.9545 10.9091 20.2455 10.9091 13.2273C10.9091 6.20909 16.6182 0.5 23.6364 0.5C39.1636 0.5 43.3818 20.7545 43.5636 21.5909C43.7818 22.6455 43.4909 23.7727 42.8 24.6091C42.1091 25.4455 41.0909 25.9545 40 25.9545ZM23.6364 7.77273C20.6182 7.77273 18.1818 10.2091 18.1818 13.2273C18.1818 16.2455 20.6182 18.6818 23.6364 18.6818H35.0909C33.3818 14.1727 29.8545 7.77273 23.6364 7.77273Z",
    fill: "#20262D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3636 25.9545H40C38.9091 25.9545 37.8909 25.4818 37.2 24.6091C36.5091 23.7727 36.2182 22.6455 36.4364 21.5909C36.6182 20.7182 40.8364 0.5 56.3636 0.5C63.3818 0.5 69.0909 6.20909 69.0909 13.2273C69.0909 20.2455 63.3818 25.9545 56.3636 25.9545ZM44.9091 18.6818H56.3636C59.3818 18.6818 61.8182 16.2455 61.8182 13.2273C61.8182 10.2091 59.3818 7.77273 56.3636 7.77273C50.1455 7.77273 46.6182 14.1727 44.9091 18.6818Z",
    fill: "#20262D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwards);
export default __webpack_public_path__ + "static/media/awards.6a8bde9dc7bedb9be55bd24e528e0305.svg";
export { ForwardRef as ReactComponent };